<template>
  <div
      v-if="typeof contact.profile === 'object'"
      class="user-profile-sidebar modern-chat-profile-panel"
      :class="{'show': shallShowActiveChatContactSidebar}"
  >
    <!-- Header / Close button -->
    <div class="profile-panel-top">
      <span
        class="profile-panel-close"
        @click="$emit('update:shall-show-active-chat-contact-sidebar', false)"
      >
        <feather-icon icon="XIcon" size="20" />
      </span>
    </div>

    <!-- Scrollable Profile Content -->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="user-profile-sidebar-area scroll-area modern-profile-scroll"
    >
      <!-- Large Portrait Photo -->
      <div class="profile-portrait-wrap">
        <img
          :src="contact.profile.image"
          :alt="contact.userName"
          class="profile-portrait-img"
        />
      </div>

      <!-- User Name & Age -->
      <div class="profile-info-block">
        <h3 class="profile-user-name">
          <router-link
              v-if="!contact.isAssistant"
              :to="{name: 'users.show', params: {id: contact.id}}"
              class="profile-name-link"
          >
            {{ contact.userName }}<span v-if="contact.profile.year">, {{ new Date().getFullYear() - contact.profile.year }}</span>
          </router-link>
          <span v-else>
            {{ contact.userName }}<span v-if="contact.profile.year">, {{ new Date().getFullYear() - contact.profile.year }}</span>
          </span>
        </h3>

        <!-- Online status indicator -->
        <div
          class="profile-online-badge"
          :class="{ offline: contact.profile.onlineStatus !== 'online' }"
        >
          <span class="online-dot" />
          <span class="online-label">{{ contact.profile.onlineStatus === 'online' ? $t('Online now') : $t('Offline') }}</span>
        </div>

        <!-- Bio / Description -->
        <div class="profile-bio-box">
          <p class="profile-bio-text">
            {{ contact.profile.description && contact.profile.description.trim() !== ''
              ? contact.profile.description
              : $t('No bio yet.') }}
          </p>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    shallShowActiveChatContactSidebar: {
      type: Boolean,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>

<style lang="scss" scoped>
.modern-chat-profile-panel {
  background: #110c22 !important;
  border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
  color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 9;
  width: 320px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  transform: translateX(110%);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.35);

  &.show {
    transform: translateX(0);
  }
}

.profile-panel-top {
  display: flex;
  justify-content: flex-end;
  padding: 14px 16px 6px;
  flex-shrink: 0;
}

.profile-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    transform: scale(1.05);
  }
}

.modern-profile-scroll {
  padding: 0 18px 24px !important;
  height: calc(100% - 52px) !important;
  overflow-y: auto;
}

.profile-portrait-wrap {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
  background: #1a1233;
  margin-bottom: 18px;
}

.profile-portrait-img {
  width: 100%;
  aspect-ratio: 0.85;
  object-fit: cover;
  display: block;
}

.profile-info-block {
  display: flex;
  flex-direction: column;
}

.profile-user-name {
  font-family: 'Lexend', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px 0;
  line-height: 1.25;

  .profile-name-link {
    color: #fff;
    text-decoration: none;

    &:hover {
      color: #ea03b2;
    }
  }
}

.profile-online-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 14px;

  .online-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #10b981;
    box-shadow: 0 0 8px #10b981;
    flex-shrink: 0;
  }

  .online-label {
    font-size: 13px;
    font-weight: 500;
    color: #10b981;
  }

  &.offline {
    .online-dot {
      background-color: #ef4444;
      box-shadow: 0 0 8px #ef4444;
    }

    .online-label {
      color: #ef4444;
    }
  }
}

.profile-bio-box {
  margin-top: 4px;

  .profile-bio-text {
    font-size: 14px;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.65);
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>
